// How many channels and programmes the reach neto form takes, and when they
// go to the back as one combined job.
//
// Without Combinado the back launches one legacy job per programme, so the
// form keeps the 15 it has taken since 2025-11-12 (it was 10 before). With
// Combinado the back joins them with " + " into a single job, so the load on
// the legacy does not grow with the count, and the owner raised that case to
// 30 on 2026-10-26.
//
// A form is { universe, kind, combined }: universe 'new' (Modelo 1) or
// 'claro', kind 'program_name' or 'time_group', combined the switch.
export const NET_REACH_LIMIT = 15;
export const NET_REACH_COMBINED_LIMIT = 30;

// Combinado is offered only for Modelo 1 programmes. Not for time slots, where
// the switch was never drawn. Not for Universo Claro since 2026-10-26: its
// script receives the joined name without --joined, and nobody has yet read
// whether it understands it (back-ratings' handoff of that day).
export const combinedOffered = ({ universe, kind }) =>
  universe === 'new' && kind === 'program_name';

// The switch's state outlives a change of universe or kind, so what is sent
// is what the client can see, not the state alone.
export const isJoined = (form) => combinedOffered(form) && Boolean(form.combined);

export const channelProgramLimit = (form) =>
  isJoined(form) ? NET_REACH_COMBINED_LIMIT : NET_REACH_LIMIT;

// A name is "<channel> - <programme>", as the back's lists serve it.
export const channelOf = (name) => name.split(' - ')[0];

// What the client is told when the form cannot be sent as it is, or null.
//
// Over the limit: only possible by switching Combinado off with more than 15
// chosen; the selection is kept and nothing is sent.
//
// Several channels combined: the legacy's reach_neto.py keeps, for households
// and for people, only the viewers of the first name's channel, over the
// windows of every programme, so the reach is wrong with no error (read in
// the legacy's code by back-ratings and by audience_colombia, 2026-10-26).
// One channel is right.
//
// A name holding " + " combined: reach_neto.py --joined splits the joined
// name on " + ", so such a name becomes two that do not exist and the job
// delivers a partial result or fails. 21 programmes held it on 2026-10-26,
// e.g. "WIN SPORTS - MUCHO + FUTBOL"; alone they are fine (back-ratings #103,
// which refuses it too).
export const netReachRefusal = (names, form) => {
  if (names.length > channelProgramLimit(form)) {
    return `Sin Combinado puedes consultar hasta ${NET_REACH_LIMIT} programas. Quita algunos o activa Combinado.`;
  }
  if (isJoined(form) && new Set(names.map(channelOf)).size > 1) {
    return 'Con Combinado todos los programas deben ser del mismo canal.';
  }
  const split = isJoined(form) && names.find((name) => name.includes(' + '));
  if (split) {
    return `Con Combinado no se puede incluir un programa cuyo nombre contiene « + »: ${split}. Consúltalo sin Combinado.`;
  }
  return null;
};
